// Maps the panel's live signals to the flow step index, 1:1 with the backend
// pipelines (see flowSteps.ts) so the animation never collapses or reorders a
// stage relative to what Azure Functions reports.

const DOC_STAGE_STEP: Readonly<Record<string, number>> = {
  queued: 0,
  preparing: 1,
  ocr: 2,
  extracting: 3,
  validating: 4,
  finalizing: 5,
};

// Auto-classified jobs get an extra "classifying" beat at index 1; every later stage shifts up by one.
// Only reached when the caller opts into the classified rail (DOCUMENT_STEPS_CLASSIFIED).
const DOC_STAGE_STEP_CLASSIFIED: Readonly<Record<string, number>> = {
  queued: 0,
  classifying: 1,
  preparing: 2,
  ocr: 3,
  extracting: 4,
  validating: 5,
  finalizing: 6,
};

const DOC_TERMINAL = new Set(['approved', 'review_required', 'rejected', 'failed', 'split']);

/**
 * Document processing → step index. Terminal statuses land on the last step (the reviewer leaves the
 * in-flight view on terminal, so this is a guard). Pass `classified` for an auto-classified job so the
 * index tracks the 7-step {@link DOCUMENT_STEPS_CLASSIFIED} rail (with the «Clasificando» beat); the
 * default tracks the 6-step manual {@link DOCUMENT_STEPS} rail unchanged.
 */
export function documentStep(
  status: string | null | undefined,
  stage: string | null | undefined,
  classified = false,
): number {
  const map = classified ? DOC_STAGE_STEP_CLASSIFIED : DOC_STAGE_STEP;
  const lastIndex = classified ? 6 : 5;
  if (status != null && DOC_TERMINAL.has(status)) {
    return lastIndex;
  }
  if (stage != null) {
    const mapped = map[stage];
    if (mapped !== undefined) {
      return mapped;
    }
  }
  return 0;
}

const DISCOVERY_STEP_STEP: Readonly<Record<string, number>> = {
  Queued: 0,
  ExtractingOcr: 1,
  AnalyzingFields: 2,
  CalculatingMaturity: 3,
  GeneratingRecommendations: 4,
  PersistingProposal: 5,
  // Terminal steps map to the last in-flight index (the wizard navigates away).
  Completed: 5,
  Failed: 5,
};

/** Discovery `DiscoveryStep` → DISCOVERY_STEPS index (1:1 with the backend enum). */
export function discoveryStep(currentStep: string | null | undefined): number {
  if (currentStep != null) {
    const mapped = DISCOVERY_STEP_STEP[currentStep];
    if (mapped !== undefined) {
      return mapped;
    }
  }
  return 0;
}
